import { useMemo } from 'react';
import { useBaseInventoryFilter, useFilter } from '../../../hooks/useFilter';
import { useAppSelector } from '../../../hooks/useAppStore';
import { getSelectedFilterItems } from '../../../store/common/selectors';
import { getInventory, getSelectedLocationId } from '../../../store/inventory/selector';
import { TVariant } from '../../../types';

export function useInventoryFilters() {
  const { baseFilters } = useBaseInventoryFilter();
  const {
    filterByCategory,
    filterByVendors,
    filterByProductType,
    filterByTags,
  } = useFilter();

  const selectedFilterItems = useAppSelector(getSelectedFilterItems);
  const selectedLocationId = useAppSelector(getSelectedLocationId);
  const inventoryItems = useAppSelector(getInventory);
  const getInventoryByFilters = useMemo(() => {
    let filteredInventory : Array<TVariant> = [];

    if (selectedLocationId === null) {
      return [];
    }

    if (selectedLocationId > 0) {
      filteredInventory = inventoryItems?.[selectedLocationId]?.variants || [];
    }

    if (selectedFilterItems.category?.length) {
      filteredInventory = filterByCategory(inventoryItems[selectedLocationId!].variants!);
    }

    if (selectedFilterItems.vendor?.length) {
      filteredInventory = filterByVendors(inventoryItems[selectedLocationId!].variants!);
    }

    if (selectedFilterItems.productTypes?.length) {
      filteredInventory = filterByProductType(inventoryItems[selectedLocationId!].variants!);
    }

    if (selectedFilterItems.tags?.length) {
      filteredInventory = filterByTags(inventoryItems[selectedLocationId!].variants!);
    }

    return filteredInventory;
  }, [selectedFilterItems, selectedLocationId, inventoryItems]);

  return {
    inventoryFilterItems: baseFilters,
    getInventoryByFilters,
  };
}
